<!-- 物流运输单提货信息部分 -->
<template>
  <div class="deliveryForm">
    <el-form
      :model="deliveryData"
      ref="deliveryForm"
      label-width="120px"
      :disabled="status == '3' || status == '4'"
    >
      <el-row>
        <el-col :span="6">
          <el-form-item
            :label="this.$t('transportOrderAdd.deliveryForm.shiptoStorageName')"
            prop="shiptoStorageName"
            :rules="{
              required: deliveryData.shiptoFlow == '' ? true : false,
              message: this.$t('transportOrderAdd.deliveryForm.shiptoStorageNamePlaceholder'),
            }"
          >
            <SearchModal
              ref="SearchModal"
              :API="wareName.API"
              className="customer-search"
              :extraData="wareName.extraData || {}"
              :query="wareName.query"
              :searchColumns="wareName.searchColumns"
              :columnList="wareName.columnList"
              :placeholder="$t('search.choose')"
              :width="'800'"
              :propCode="wareName.propCode"
              :propName="wareName.propName"
              :currentValue="wareName.currentValue || null"
              :checkRowKeys="wareName.checkRowKeys"
              :isMultiple="true"
              @setSearchModal="setShiptoStorage"
              @setSearchModalInput="setSearchModalInput"
              :isReadOnly="false"
              :disabled="deliveryData.shiptoFlow == '' ? false : true"
            ></SearchModal>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :label="this.$t('transportOrderAdd.deliveryForm.shiptoFlow')"
            prop="shiptoFlow"
            :rules="{
              required:
                deliveryData.shiptoStorageAddress == null || deliveryData.shiptoStorageName == null
                  ? true
                  : false,
              message: this.$t('transportOrderAdd.deliveryForm.shiptoFlowPlaceholder'),
            }"
          >
            <el-input
              :placeholder="this.$t('transportOrderAdd.deliveryForm.shiptoFlowPlaceholder')"
              v-model="deliveryData.shiptoFlow"
              @blur="wareOrShiptoFlow"
              clearable
              maxlength="32"
              :disabled="
                deliveryData.shiptoStorageAddress && deliveryData.shiptoStorageName ? true : false
              "
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :label="this.$t('transportOrderAdd.deliveryForm.shiptoStorageAddress')"
            prop="shiptoStorageAddress"
            :rules="{
              required: deliveryData.shiptoFlow == '' ? true : false,
              message: this.$t('transportOrderAdd.deliveryForm.shiptoStorageAddressPlaceholder'),
            }"
          >
            <el-input
              :placeholder="
                this.$t('transportOrderAdd.deliveryForm.shiptoStorageAddressPlaceholder')
              "
              :disabled="deliveryData.shiptoFlow == '' ? false : true"
              v-model="deliveryData.shiptoStorageAddress"
              clearable
              maxlength="32"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :label="this.$t('transportOrderAdd.deliveryForm.shiptoContactPerson')"
            prop="shiptoContactPerson"
          >
            <el-input
              :placeholder="
                this.$t('transportOrderAdd.deliveryForm.shiptoContactPersonPlaceholder')
              "
              v-model="deliveryData.shiptoContactPerson"
              clearable
              maxlength="32"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="6">
          <el-form-item
            :label="this.$t('transportOrderAdd.deliveryForm.shiptoContactTelephone')"
            prop="shiptoContactTelephone"
          >
            <el-input
              :placeholder="
                this.$t('transportOrderAdd.deliveryForm.shiptoContactTelephonePlaceholder')
              "
              v-model="deliveryData.shiptoContactTelephone"
              clearable
              maxlength="32"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :label="this.$t('transportOrderAdd.deliveryForm.shiptoStorageTelephone')"
            prop="shiptoStorageTelephone"
          >
            <el-input
              :placeholder="
                this.$t('transportOrderAdd.deliveryForm.shiptoStorageTelephonePlaceholder')
              "
              v-model="deliveryData.shiptoStorageTelephone"
              clearable
              maxlength="32"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :label="this.$t('transportOrderAdd.deliveryForm.shiptoStorageArea')"
            prop="shiptoStorageArea"
          >
            <el-input
              :placeholder="this.$t('transportOrderAdd.deliveryForm.shiptoStorageAreaPlaceholder')"
              v-model="deliveryData.shiptoStorageArea"
              clearable
              maxlength="32"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :label="this.$t('transportOrderAdd.deliveryForm.shiptoEntity')"
            prop="shiptoEntity"
          >
            <el-input
              :placeholder="this.$t('transportOrderAdd.deliveryForm.shiptoEntityPlaceholder')"
              v-model="deliveryData.shiptoEntity"
              clearable
              maxlength="32"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item
            :label="this.$t('transportOrderAdd.deliveryForm.shiptoDemand')"
            prop="shiptoDemand"
          >
            <el-input
              :placeholder="this.$t('transportOrderAdd.deliveryForm.shiptoDemandPlaceholder')"
              v-model="deliveryData.shiptoDemand"
              clearable
              maxlength="126"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            :label="this.$t('transportOrderAdd.deliveryForm.shiptoMark')"
            prop="shiptoMark"
          >
            <el-input
              :placeholder="this.$t('transportOrderAdd.deliveryForm.shiptoMarkPlaceholder')"
              v-model="deliveryData.shiptoMark"
              clearable
              maxlength="126"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>
<script>
  import { mapState } from 'vuex';
  import SearchModal from '@/components/SearchModal';
  // import searchTable from '@/components/form-item/search-table';
  import COMPANY_API from '@/api/masterData/company';

  export default {
    name: 'deliveryForm',
    components: {
      // searchTable,
      SearchModal,
    },
    props: ['isEdit', 'allDetail', 'status'],
    mounted() {},
    computed: {
      ...mapState({
        userInfo: (state) => state.userInfo.userInfo,
      }),
      wareName() {
        return {
          API: COMPANY_API.GET_STORAGE_LIST,
          query: {
            storageCode: '',
            storageName: '',
          },
          propCode: 'storageCode',
          propName: 'storageName',
          currentValue: this.deliveryData.shiptoStorageName,
          checkRowKeys: [this.deliveryData.shiptoStorageNo],
          extraData: {
            adminFlag: this.userInfo.adminFlag,
            //已生效的仓库
            currentStatus: 'ZT03',
          },
          searchColumns: [
            {
              name: this.$t('warehouse.search.warehouseCode'),
              prop: 'storageCode',
              type: 'input',
            },
            {
              name: this.$t('warehouse.search.warehouseName'),
              prop: 'storageName',
              type: 'input',
            },
          ],
          columnList: [
            {
              prop: 'storageCode',
              label: this.$t('warehouse.table.createWarehouseCode'),
            },
            {
              prop: 'storageName',
              label: this.$t('warehouse.table.createWarehouseName'),
            },
            {
              prop: 'storageAddress',
              label: this.$t('warehouse.table.createWarehouseAddress'),
            },
          ],
        };
      },
      wareAddress() {
        return {
          API: COMPANY_API.GET_STORAGE_LIST,
          query: {
            storageCode: '',
            storageName: '',
          },
          propCode: 'storageCode',
          propName: 'storageAddress',
          currentValue: this.deliveryData.shiptoStorageAddress,
          checkRowKeys: [this.deliveryData.shiptoStorageNo],
          extraData: {
            adminFlag: this.userInfo.adminFlag,
            //已生效的仓库
            currentStatus: 'ZT03',
          },
          searchColumns: [
            {
              name: this.$t('warehouse.search.warehouseCode'),
              prop: 'storageCode',
              type: 'input',
            },
            {
              name: this.$t('warehouse.search.warehouseName'),
              prop: 'storageName',
              type: 'input',
            },
            {
              name: this.$t('warehouse.search.storageAddress'),
              prop: 'storageAddress',
              type: 'input',
            },
          ],
          columnList: [
            {
              prop: 'storageCode',
              label: this.$t('warehouse.table.createWarehouseCode'),
            },
            {
              prop: 'storageName',
              label: this.$t('warehouse.table.createWarehouseName'),
            },
            {
              prop: 'storageAddress',
              label: this.$t('warehouse.table.createWarehouseAddress'),
            },
          ],
        };
      },
      wareTel() {
        return {
          API: COMPANY_API.GET_STORAGE_LIST,
          query: {
            storageCode: '',
            storageName: '',
          },
          propCode: 'storageCode',
          propName: 'contactTelephone',
          currentValue: this.deliveryData.shiptoStorageTelephone,
          checkRowKeys: [],
          extraData: {
            adminFlag: this.userInfo.adminFlag,
            //已生效的仓库
            currentStatus: 'ZT03',
          },
          searchColumns: [
            {
              name: this.$t('warehouse.search.warehouseCode'),
              prop: 'storageCode',
              type: 'input',
            },
            {
              name: this.$t('warehouse.search.warehouseName'),
              prop: 'storageName',
              type: 'input',
            },
          ],
          columnList: [
            {
              prop: 'storageCode',
              label: this.$t('warehouse.table.createWarehouseCode'),
            },
            {
              prop: 'storageName',
              label: this.$t('warehouse.table.createWarehouseName'),
            },
            {
              prop: 'contactTelephone',
              label: this.$t('warehouse.table.contractTelephone'),
            },
          ],
        };
      },
    },
    data() {
      return {
        // 顶部表单
        deliveryData: {
          shiptoStorageNo: '',
          shiptoStorageName: '',
          shiptoFlow: '',
          shiptoStorageAddress: '',
          shiptoContactPerson: '',
          shiptoContactTelephone: '',
          shiptoStorageTelephone: '',
          shiptoStorageArea: '',
          shiptoEntity: '',
          shiptoDemand: '',
          shiptoMark: '',
        },
        isShiptoStorageName: true,
        isShiptoFlow: true,
        isShiptoStorageAddress: true,
      };
    },
    methods: {
      getDeatil(allDetail) {
        if (this.status != 0) {
          let deliveryData = {};
          Object.keys(this.deliveryData).forEach((item) => {
            deliveryData[`${item}`] = allDetail.delivery[`${item}`] || '';
          });
          this.deliveryData = deliveryData;
          this.deliveryData.shiptoStorageName = deliveryData.shiptoStorageName;
          this.wareOrShiptoFlow();
        }
      },
      setShiptoStorage(type, row) {
        this.deliveryData.shiptoStorageNo = row ? row[0].storageCode : null;
        this.deliveryData.shiptoStorageName = row ? row[0].storageName : null;
        this.deliveryData.shiptoStorageAddress = row ? row[0].storageAddress : null;
        this.deliveryData.shiptoStorageTelephone = row ? row[0].contactTelephone : null;
        this.deliveryData.shiptoFlow = '';
        this.wareOrShiptoFlow();
      },
      //手动输入时
      setSearchModalInput(type, val) {
        this.deliveryData.shiptoStorageName = val;
      },
      wareOrShiptoFlow() {
        if (
          this.deliveryData.shiptoStorageName != '' ||
          this.deliveryData.shiptoStorageAddress != ''
        ) {
          this.isShiptoStorageName = true;
          this.isShiptoStorageAddress = true;
          this.isShiptoFlow = false;
        } else if (this.deliveryData.shiptoFlow != '') {
          this.isShiptoStorageName = false;
          this.isShiptoStorageAddress = false;
          this.isShiptoFlow = true;
        } else {
          this.isShiptoStorageName = true;
          this.isShiptoStorageAddress = true;
          this.isShiptoFlow = true;
        }
        if (this.deliveryData.shiptoFlow) {
          this.deliveryData.shiptoStorageNo = null;
          this.deliveryData.shiptoStorageName = null;
          this.deliveryData.shiptoStorageAddress = null;
          this.deliveryData.shiptoStorageTelephone = null;
        }
        this.$refs.deliveryForm.clearValidate();
      },
      // 选择各种单号后带出的详情
      getChooseDetail(obj) {
        let deliveryData = {};
        if (obj.detail) {
          Object.keys(this.deliveryData).forEach((item) => {
            deliveryData[`${item}`] = obj.detail[`${item}`] || this.deliveryData[`${item}`];
          });
        } else {
          deliveryData = this.deliveryData;
          deliveryData.shiptoStorageNo = '';
          deliveryData.shiptoStorageName = '';
          deliveryData.shiptoFlow = '';
          deliveryData.shiptoStorageTelephone = '';
          deliveryData.shiptoStorageAddress = '';
          deliveryData.shiptoContactPerson = '';
          deliveryData.shiptoContactTelephone = '';
        }
        this.deliveryData = deliveryData;
        if (this.deliveryData.shiptoStorageNo || this.deliveryData.shiptoStorageAddress) {
          this.deliveryData.shiptoFlow = '';
        } else if (this.deliveryData.shiptoFlow) {
          this.deliveryData.shiptoStorageNo = '';
          this.deliveryData.shiptoStorageAddress = '';
          this.deliveryData.shiptoStorageTelephone = '';
        }
        this.wareOrShiptoFlow();
      },
      // 返回数据
      exportChildData(btnType) {
        if (btnType == '4') {
          let sign = false;
          this.$refs.deliveryForm.validate((valid) => {
            if (valid) {
              sign = true;
            } else {
              sign = false;
            }
          });
          return sign ? this.deliveryData : false;
        } else {
          return this.deliveryData;
        }
      },
    },
  };
</script>
<style lang="scss" scoped>
  .deliveryForm .widthStyle {
    width: 100%;
  }
</style>
